import Box from '@mui/material/Box';

//typography
import {
	Body1,
	Headline6,
} from '../../../components/UI/MDC/Typography/Typography';

function ResultTable({ user, ...props }) {
	return (
		<>
			<Box className='center'>
				<Headline6>{user.Name?.replace(/,(?! )/, ', ')}</Headline6>
				<Headline6>{user.JobTitle}</Headline6>
			</Box>
			<Box display='flex' max-width='100%' justify-content='center'>
				<Box className='left'>
					<div>
						<Body1>
							<strong>Department</strong>
							<div />
							{user.Department}
						</Body1>
						<Body1>
							<strong>Supervisor</strong>
							<div />
							{user.Manager?.replace(/,(?! )/, ', ')}
						</Body1>
						<Body1>
							<strong>Account type</strong>
							<div />
							{user.AccountType}
						</Body1>
					</div>
				</Box>
				<Box className='right'>
					<div>
						<Body1>
							<strong>Network ID</strong>
							<div />
							{user.NetworkID}
						</Body1>
						<Body1>
							<strong>Public ESO</strong>
							<div />
							{user.PublicESOID}
						</Body1>
						<Body1>
							<strong>Familiar ESO</strong>
							<div />
							{user.FamiliarESOID}
						</Body1>
					</div>
				</Box>
			</Box>
			<Box className='bottom'>
				<Body1>
					<strong>User Principle Name (UPN)</strong>
					<div />
					{user.UPN}
				</Body1>
			</Box>
		</>
	);
}
export default ResultTable;
